import { CartViewFooter } from "../../cpq/overrides/CartViewFooter/CartViewFooter";
import { CartViewHeading } from "../../cpq/overrides/CartViewHeading/CartViewHeading";
import { CustomLineItems } from "../CustomLineItems/CustomLineItems";

import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import { useQuotesServiceGetByIdQuotes } from "@4pace-cpq/core";
import { Box, Container } from "@mui/material";
import { useNavigate, useParams } from "@tanstack/react-router";

export type ErrorType = {
  applicationProductId: string;
  exceptionMessage: string;
};

export function CustomCartIdRouteComponent({
  isLoggedIntoEasy,
}: {
  isLoggedIntoEasy: boolean;
}): JSX.Element | null {
  const { cartId } = useParams({ strict: false });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: item, isLoading } = useQuotesServiceGetByIdQuotes({
    id: cartId,
    // includes are set on the backend
  });
  const [errorList, setErrorList] = useState<ErrorType[]>();

  if (!item && !isLoading) {
    navigate({
      to: "/",
    });
  }

  const firstItemGroup = item?.itemGroups?.[0];

  if (isLoading || !item || !firstItemGroup) {
    return null;
  }
  const lineItems = firstItemGroup?.lineItems;
  let allConfigsComplete = false;
  let configurationsIncomplete = 0;
  lineItems?.forEach((lineItem) => {
    console.log(lineItem.isConfigurationComplete, lineItem);

    if (!lineItem.isConfigurationComplete) {
      configurationsIncomplete++;
    }
  });
  if (configurationsIncomplete === 0) {
    allConfigsComplete = true;
  }
  console.log(configurationsIncomplete, allConfigsComplete);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      flexGrow="1"
    >
      <Container>
        <CartViewHeading item={item} itemGroupId={firstItemGroup.id} />

        {lineItems?.length ? (
          <CustomLineItems
            isLoggedIntoEasy={isLoggedIntoEasy}
            customerId={item.customerId}
            quoteId={item.id}
            lineItems={lineItems}
            itemGroupId={firstItemGroup.id}
            errorList={errorList}
          />
        ) : (
          <Box p={4}>
            <span>{t("WEG:ProjectListEmptyMsg")}</span>
          </Box>
        )}
      </Container>
      <CartViewFooter
        isLoggedIntoEasy={isLoggedIntoEasy}
        lineItems={lineItems}
        setErrorList={setErrorList}
        allConfigsComplete={allConfigsComplete}
      />
    </Box>
  );
}
